var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomZoneAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#0065FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7501 10.4709C18.0162 9.73646 17.0395 9.33203 16.0007 9.33203C14.9618 9.33203 13.9851 9.73646 13.2507 10.4709C11.7345 11.9869 11.7345 14.454 13.2551 15.9745L14.6412 17.33C15.0162 17.6967 15.5084 17.88 16.0007 17.88C16.4929 17.88 16.9851 17.6967 17.3601 17.33L18.7501 15.9701C19.4845 15.2357 19.8895 14.259 19.8895 13.2202C19.8895 12.1814 19.4845 11.2058 18.7501 10.4709ZM16.0007 14.8818C15.0801 14.8818 14.334 14.1357 14.334 13.2152C14.334 12.2947 15.0801 11.5486 16.0007 11.5486C16.9212 11.5486 17.6673 12.2947 17.6673 13.2152C17.6673 14.1357 16.9212 14.8818 16.0007 14.8818ZM22.6673 18.6439C22.6684 18.8405 22.5656 19.0227 22.3979 19.1233L16.9195 22.4104C16.6362 22.5804 16.3184 22.6654 16.0012 22.6654C15.684 22.6654 15.3657 22.5804 15.0829 22.4104L9.60344 19.1233C9.4351 19.0222 9.33288 18.84 9.33399 18.6439C9.3351 18.4478 9.43955 18.2667 9.60899 18.1678L12.3062 16.589C12.3618 16.6501 12.419 16.7106 12.4779 16.7695L13.864 18.1244C14.4351 18.6833 15.1945 18.9916 16.0007 18.9916C16.8068 18.9916 17.5656 18.6833 18.1373 18.1244L19.5362 16.7562C19.5906 16.7017 19.644 16.6456 19.6956 16.589L22.3923 18.1672C22.5618 18.2667 22.6662 18.4483 22.6673 18.6439Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomZoneAct);
export default __webpack_public_path__ + "static/media/customZoneAct.8f528982d7ce9b0f84454efb26b696f0.svg";
export { ForwardRef as ReactComponent };